import { Form, OriSelect, Button } from '@/src/components/Antd';
import { RadioGroup, RadioItem } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { SalesChannelMode } from 'src/types/common/SalesChannel';
import { generalFilterOptions } from 'src/tools/helper';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const WebsiteFields = {
  siteMode: 'siteMode',
  sisterSalesChannelUuid: 'sisterSalesChannelUuid',
};

const WebsiteMode = ({ form, sisterSalesChannelList }) => {
  const i18n = useI18n();
  const Item = Form.Item;
  const getI18n = (str) => i18nGet(i18n, str);

  const [radioValue, setRadioValue] = useState(
    form.getFieldValue(WebsiteFields.siteMode),
  );

  const handleOnSubmit = () => {
    if (radioValue !== SalesChannelMode.INFO_SISTER) {
      form.setFieldsValue({ sisterSalesChannelUuid: '' });
    }
    form.submit();
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelDomainAndStatus.list.websiteMode')}>
      <div className={css.modetitle}>
        {getI18n('salesChannelDomainAndStatus.list.websiteMode')}
      </div>
      <div className={css.modeInfo}>
        {getI18n('salesChannelDomainAndStatus.list.websiteModeDesc')}
      </div>
      <Item name={WebsiteFields.siteMode}>
        <RadioGroup
          value={radioValue}
          className={css.radioGroup}
          onChange={(e) => {
            setRadioValue(e.target.value);
          }}>
          <RadioItem
            className={css.radioItem}
            value={SalesChannelMode.ECOMMERCE}
            key={SalesChannelMode.ECOMMERCE}>
            {getI18n('salesChannelDomainAndStatus.list.ecommerceSite')}
          </RadioItem>
          <RadioItem
            className={css.radioItem}
            value={SalesChannelMode.INFO}
            key={SalesChannelMode.INFO}>
            {getI18n('salesChannelDomainAndStatus.list.infoSiteOnly')}
          </RadioItem>
          <RadioItem
            className={css.radioItem}
            value={SalesChannelMode.INFO_SISTER}
            key={SalesChannelMode.INFO_SISTER}>
            {getI18n('salesChannelDomainAndStatus.list.sisterSaleschannel')}
          </RadioItem>
        </RadioGroup>
      </Item>

      {radioValue === SalesChannelMode.INFO_SISTER && (
        <Item
          className={css.selectContainer}
          name={WebsiteFields.sisterSalesChannelUuid}
          rules={[
            {
              required: true,
              message: getI18n(
                'salesChannelDomainAndStatus.list.websiteModeError',
              ),
            },
          ]}>
          <div>
            <div className={css.selectInfo}>
              {getI18n(
                'salesChannelDomainAndStatus.list.sisterSaleschannelDesc',
              )}
            </div>
            <OriSelect
              showSearch
              filterOption={generalFilterOptions}
              defaultValue={form.getFieldValue(
                WebsiteFields.sisterSalesChannelUuid,
              )}
              onSelect={(value) => {
                form.setFieldsValue({ sisterSalesChannelUuid: value });
              }}
              onSearch={(value) => {
                const validOption = sisterSalesChannelList.find(
                  (i) => i.uuid === value,
                );
                if (!validOption) {
                  form.setFieldsValue({ sisterSalesChannelUuid: null });
                }
              }}
              style={{ width: 229 }}>
              {(sisterSalesChannelList || []).map((i) => {
                const { uuid, name } = i;
                return (
                  <OriSelect.Option value={uuid} key={uuid}>
                    {name}
                  </OriSelect.Option>
                );
              })}
            </OriSelect>
          </div>
        </Item>
      )}
      <div className={css.buttonCombin}>
        <Button type='primary' onClick={() => handleOnSubmit()}>
          {getI18n('general.save')}
        </Button>
      </div>
    </SectionWrapper>
  );
};
export default WebsiteMode;
